import React from "react";
import Avatar from "react-avatar";
import Grid from "@mui/material/Grid";
import SubCard from '../berry/ui-component/cards/SubCard';

const PreviewAvatar = ({image, handleEdit, avatarClass, ...props }) => {


    return <SubCard title="Mon avatar" contentSX={{ textAlign: 'center' }}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Avatar
                    src={image}
                    alt={"used-avatar"}
                    title={"avatar-profil"}
                    {...props}
                />
            </Grid>
        </Grid>
    </SubCard>
}

export default PreviewAvatar
